var _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductDocengine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Documents structured into an accessible document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62 25) rotate(-8 50 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 140,
    rx: 10,
    fill: "#E8EDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 29h62M19 45h53M19 61h38",
    stroke: "#A6B2C2",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 99h34m-8-8 8 8-8 8",
    stroke: "#CDB8A8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 288 98)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 20,
    width: 112,
    height: 156,
    rx: 10,
    fill: "#FFF1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 47h69",
    stroke: "#A27A5F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 66h57M253 81h69M253 96h43",
    stroke: "#CDB8A8",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 118,
    width: 78,
    height: 36,
    rx: 18,
    fill: "#DEEEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277 136 8 8 15-18",
    stroke: "#357653",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDocengine);
export default __webpack_public_path__ + "static/media/product-docengine.806edd1781215a722c8ef46a45e6486c.svg";
export { ForwardRef as ReactComponent };